import PlanChangePaymentForm from '../../../../payment/PlanChangePaymentForm'

const ResumePlanConfirmContent = ({
  currentPlan,
  ufValue,
  cards = [],
  selectedCardId,
  onSelectedCardChange,
  onPaymentSuccess,
  isPending,
  errorMessage,
  customerId,
  cardsIds
}) => {
  const amount =
    currentPlan?.ufPriceWithoutTaxes != null && ufValue
      ? Math.round(Number(currentPlan.ufPriceWithoutTaxes) * ufValue * 1.19)
      : 1

  return (
    <div className="space-y-4 relative">
      {isPending && (
        <div className="absolute inset-0 bg-white/90 rounded-lg flex flex-col items-center justify-center z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-accent1 mb-4" />
          <h3 className="text-xl font-bold text-gray-900 mb-2">Retomando plan</h3>
          <p className="text-gray-600 text-center">Registrando preaprobación…</p>
        </div>
      )}
      <p className="text-sm text-gray-600">
        Autoriza el débito recurrente para retomar el plan <strong>{currentPlan?.name || ''}</strong>. No hay cobro
        inmediato; se reactivan los cargos según el ciclo del plan.
      </p>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <p className="text-sm text-blue-800">
          <strong>Importante:</strong> usa la misma autorización que al confirmar una suscripción (preaprobación). Si
          acabas de registrar la tarjeta con &quot;Guardar tarjeta&quot;, elige esa tarjeta aquí.
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-3 pt-1">
        <label className="text-sm font-medium text-gray-700">Tarjeta para retomar</label>
        {cards.length <= 1 ? (
          <span className="text-sm text-gray-700">
            {cards[0]
              ? `${cards[0].name || cards[0].cardType} •••• ${cards[0].lastFourDigits}`
              : '—'}
          </span>
        ) : (
          <select
            value={selectedCardId}
            onChange={(e) => onSelectedCardChange?.(e.target.value)}
            disabled={isPending}
            className="min-w-[220px] border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent2/50"
          >
            <option value="">Selecciona una tarjeta</option>
            {cards.map((card) => (
              <option key={card.id} value={String(card.id)}>
                {card.name || card.cardType} •••• {card.lastFourDigits}
              </option>
            ))}
          </select>
        )}
      </div>

      {errorMessage && (
        <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">{errorMessage}</div>
      )}

      {selectedCardId && cardsIds.length > 0 ? (
        <PlanChangePaymentForm
          key={`planResume-${selectedCardId}`}
          amount={amount}
          onSuccess={onPaymentSuccess}
          customerId={customerId}
          cardsIds={cardsIds}
          showSavedCard={false}
          brickId="planChangeConfirm"
          flowType="plan_resume"
          successMessage="Plan retomado correctamente."
        />
      ) : (
        <p className="text-sm text-amber-700">Selecciona una tarjeta para continuar.</p>
      )}
    </div>
  )
}

export default ResumePlanConfirmContent
